import { create } from "zustand";

export interface FormValues {
	applicationType: string;
	firstName: string;
	lastName: string;
	email: string;
	state: string;
	loanAmount: string;
	phone: string;
	loanPurpose: string;
	loanType: string;
	assetType: string;
	purchaseStage: string;
	assetAge: string;
	purchaseFrom: string;
	livingStatus: string;
	employmentStatus: string;
	abnStatus: string;
	gstStatus: string;
	combinedIncome: string;
	creditHistory: string;
	// Business Loan
	businessAbnStatus: string;
	businessName: string;
	financeReason: string;
	// Mortgage Loan
	isFirstHomeBuyer: string;
	propertyValue: string;
	propertyDeposit: string;
	existingLender: string;
	refinancePurpose: string;
	existingLoanBalance: string;
	isInFixedRate: string;
	fixedRateEndDate: string;
	interestRate: string;
}

export const initialFormValues: FormValues = {
	applicationType: "",
	firstName: "",
	lastName: "",
	email: "",
	state: "",
	loanAmount: "",
	phone: "",
	loanPurpose: "",
	loanType: "",
	assetType: "",
	purchaseStage: "",
	assetAge: "",
	purchaseFrom: "",
	livingStatus: "",
	employmentStatus: "",
	abnStatus: "",
	gstStatus: "",
	combinedIncome: "",
	creditHistory: "",
	// Business Loan
	businessAbnStatus: "",
	businessName: "",
	financeReason: "",
	// Mortgage Loan
	isFirstHomeBuyer: "",
	propertyValue: "",
	propertyDeposit: "",
	existingLender: "",
	refinancePurpose: "",
	existingLoanBalance: "",
	isInFixedRate: "",
	fixedRateEndDate: "",
	interestRate: "",
};

export interface FormData {
	formValues: FormValues;

	// Initializes formValues
	resetFormValues: () => void;

	// Initializes formValues except selected fields
	resetFormValuesExcept: (excludeKeys: (keyof FormValues)[]) => void;

	// Setter function to update specific fields
	setFormValue: (field: keyof FormValues, value: string) => void;
}

export const useFormData = () =>
	create<FormData>((set) => ({
		formValues: { ...initialFormValues },

		resetFormValues: () =>
			set(() => ({
				formValues: { ...initialFormValues },
			})),

		resetFormValuesExcept: (excludeKeys) =>
			set((state) => {
				const preservedValues = excludeKeys.reduce((acc, key) => {
					acc[key] = state.formValues[key];
					return acc;
				}, {} as Partial<FormValues>);

				return {
					formValues: {
						...initialFormValues,
						...preservedValues,
					},
				};
			}),

		// Dynamic setter function to update form fields
		setFormValue: (field, value) =>
			set((state) => ({
				formValues: {
					...state.formValues,
					[field]: value,
				},
			})),
	}));
